import { createContext, PropsWithChildren, useContext } from "react";
import { Configuration, useGetConfigurationQuery } from "../api/get-configuration";
import { useAuthContext } from "@/features/auth/contexts/auth-context";

export interface ConfigurationContextReturn extends Configuration {
    loading: boolean,
    error: Error | undefined
}

const ConfigurationContext = createContext<ConfigurationContextReturn>(null!);

export function useConfigurationContext() {
    return useContext(ConfigurationContext);
}

export function ConfigurationProvider({
    children
}: PropsWithChildren) {
    const { isLoggedIn } = useAuthContext();
    const { data: configuration, isLoading, error } = useGetConfigurationQuery({ enabled: isLoggedIn });

    return <ConfigurationContext.Provider value={{
        ...configuration!,
        loading: isLoading,
        error: error || undefined
    }}>
        {children}
    </ConfigurationContext.Provider>
}